/**
 * 检查 URL 是否可用
 * @param url 要检查的 URL
 * @returns Promise<boolean> URL 是否可用
 */
export const checkUrlAvailable = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url);
    return response.ok;
  } catch {
    return false;
  }
};
